import Service from "../Service";
const resource = "HmnEducationalInstitution/";

export default {
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    list(requestID) {
        return Service.post(resource + "list", {}, {
            params: { requestID: requestID },
        });
    },
    upload(list, requestID) {
        return Service.post(resource + "upload", list, {
            params: { requestID: requestID },
        });
    }
};
